document.addEventListener("DOMContentLoaded", function () {
  const formEvent = document.querySelector(".js-form-events-filters");

  if (document.querySelectorAll(".js-calendar-inline").length > 0) {
    flatpickr(".js-calendar-inline", {
      locale: "fr",
      inline: true,
      disableMobile: "true",
      mode: "range",
      dateFormat: "Y-m-d",
      showMonths: 1,
      static: true,
      minDate: "today",
      onChange: function (selectedDates, dateStr, instance) {
        // format date to Y-m-d
        if (selectedDates.length > 1) {
          const dateStart = new Date(selectedDates[0]);
          const dateEnd = new Date(selectedDates[1]);

          // console.log("dateStart", dateStart, String(dateStart.getMonth() + 1).padStart(2, "0"), dateStart.getFullYear(), String(dateStart.getDate()).padStart(2, "0"));
          // console.log("dateEnd", dateEnd, String(dateEnd.getMonth() + 1).padStart(2, "0"), dateEnd.getFullYear(), String(dateEnd.getDate()).padStart(2, "0"));

          document.querySelector("#date-event-start").value = `${dateStart.getFullYear()}-${String(dateStart.getMonth() + 1).padStart(2, "0")}-${String(dateStart.getDate()).padStart(2, "0")}`;
          document.querySelector("#date-event-end").value = `${dateEnd.getFullYear()}-${String(dateEnd.getMonth() + 1).padStart(2, "0")}-${String(dateEnd.getDate()).padStart(2, "0")}`;
          document.querySelector("#page-to-fetch").value = "";
          document.querySelectorAll(".js-btn-load-more-event-month").forEach((btn) => {
            btn.setAttribute("data-page", 2);
          });

          const btnShowResults = document.querySelectorAll(".js-btn-show-results");
          btnShowResults.forEach((btnShowResult) => {
            btnShowResult.classList.remove("hidden");
          });
        }
      },
    });
  }

  if (document.querySelectorAll(".js-btn-show-results").length > 0) {
    const btnShowResults = document.querySelectorAll(".js-btn-show-results");

    for (const btnShowResult of btnShowResults) {
      btnShowResult.addEventListener("click", function (e) {
        e.preventDefault();
        console.log("show results");

        const submitEvent = new Event("submit", { cancelable: true });
        formEvent.dispatchEvent(submitEvent);
      });
    }
  }

  if (formEvent) {
    formEvent.addEventListener("submit", function (e) {
      e.preventDefault();

      const listEvents = document.querySelector(".js-list-events");
      const overlayLoading = document.querySelector(".overlay-loading");

      if (overlayLoading) {
        overlayLoading.classList.remove("hidden");
      }

      const formData = new FormData(formEvent);
      const params = new URLSearchParams(formData);
      const url = `${formEvent.action}?${params.toString()}`;
      let actionType = document.querySelector("#action-type").value;

      console.log("form url", url);

      fetch(url, {
        method: "GET",
      })
        .then((response) => response.text())
        .then((html) => {
          let parser = new DOMParser();
          let htmlDoc = parser.parseFromString(html, "text/html");
          if (overlayLoading) {
            overlayLoading.classList.add("hidden");
          }
          if (actionType == "load-month") {
            const newEventsContainer = htmlDoc.querySelector(".js-list-events");
            listEvents.append(...newEventsContainer.children);
            document.querySelector("#action-type").value = "";
            if (!htmlDoc.querySelector(".js-btn-load-more-event-month")) {
              document.querySelector(".js-btn-load-more-event-month").classList.add("hidden");
            }
            // if (htmlDoc.querySelector(".js-btn-load-more-event-month")) {
            //   document.querySelector(".js-btn-load-more-event-month").dataset.fromload = htmlDoc.querySelector(".js-btn-load-more-event-month").dataset.fromload;
            //   document.querySelector(".js-btn-load-more-event-month").dataset.toload = htmlDoc.querySelector(".js-btn-load-more-event-month").dataset.toload;
            // } else {
            //   document.querySelector(".js-btn-load-more-event-month").classList.add("hidden");
            // }
          } else {
            listEvents.innerHTML = htmlDoc.querySelector(".js-list-events").innerHTML;
            if (!htmlDoc.querySelector(".js-btn-load-more-event-month")) {
              document.querySelector(".js-btn-load-more-event-month").classList.add("hidden");
            }

            // if (htmlDoc.querySelector(".js-btn-load-more-event-month")) {
            //   document.querySelector(".js-btn-load-more-event-month").dataset.fromload = htmlDoc.querySelector(".js-btn-load-more-event-month").dataset.fromload;
            //   document.querySelector(".js-btn-load-more-event-month").dataset.toload = htmlDoc.querySelector(".js-btn-load-more-event-month").dataset.toload;
            //   document.querySelector(".js-btn-load-more-event-month").classList.remove("hidden");
            // } else {
            //   document.querySelector(".js-btn-load-more-event-month").classList.add("hidden");
            // }
          }
        })
        .catch((error) => {
          console.error(error);
          if (overlayLoading) {
            overlayLoading.classList.add("hidden");
          }
        });
    });
  }

  if (document.querySelectorAll(".js-select-month-events").length > 0) {
    const selectMonths = document.querySelectorAll(".js-select-month-events");

    for (const selectMonth of selectMonths) {
      selectMonth.addEventListener("change", function () {
        if (selectMonth.value == "all") {
          document.querySelector("#date-event-start").value = "";
          document.querySelector("#date-event-end").value = "";
        } else {
          const selectedMonth = selectMonth.value.split("//");
          let fromField = document.querySelector("#date-event-start");
          let toField = document.querySelector("#date-event-end");
          fromField.value = selectedMonth[0];
          toField.value = selectedMonth[1];
        }

        const submitEvent = new Event("submit", { cancelable: true });
        formEvent.dispatchEvent(submitEvent);
      });
    }
  }

  if (document.querySelectorAll(".js-btn-load-more-event-month").length > 0) {
    const btnLoadMoreEventMonths = document.querySelectorAll(".js-btn-load-more-event-month");

    for (const btnLoadMoreEventMonth of btnLoadMoreEventMonths) {
      btnLoadMoreEventMonth.addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector("#action-type").value = "load-month";
        // document.querySelector("#date-event-start").value = btnLoadMoreEventMonth.dataset.fromload;
        // document.querySelector("#date-event-end").value = btnLoadMoreEventMonth.dataset.toload;
        document.querySelector("#page-to-fetch").value = btnLoadMoreEventMonth.dataset.page;
        btnLoadMoreEventMonth.setAttribute("data-page", parseInt(btnLoadMoreEventMonth.dataset.page) + 1);

        const submitEvent = new Event("submit", { cancelable: true });
        formEvent.dispatchEvent(submitEvent);
      });
    }
  }

  if (document.querySelectorAll(".js-select-categorie-events").length > 0) {
    const selectCategories = document.querySelectorAll(".js-select-categorie-events");

    for (const selectCategory of selectCategories) {
      selectCategory.addEventListener("change", function () {
        var value = selectCategory.value;
        var text = selectCategory.options[selectCategory.selectedIndex].text;
        var type = selectCategory.options[selectCategory.selectedIndex].dataset.type;
        var existingTags = selectCategory.options[selectCategory.selectedIndex].dataset.tags;
        var existingTagsEventsLu = selectCategory.options[selectCategory.selectedIndex].dataset.tagseventslu;

        // console.log("Categorie", value, text, type, existingTags, existingTagsEventsLu, selectCategory.options[selectCategory.selectedIndex]);

        if (value == "all") {
          document.querySelector("input[name='categories']").value = "";
          document.querySelector("input[name='tags']").value = "";
          document.querySelector("input[name='tagsEventsLu']").value = "";
        }

        if (type == "categories") {
          document.querySelector("input[name='categories']").value = value;
          document.querySelector("input[name='tags']").value = "";
          document.querySelector("input[name='tagsEventsLu']").value = "";
        }

        if (type == "tags") {
          // console.log("tags", value);
          document.querySelector("input[name='tags']").value = existingTags ? existingTags + "," + value : value;
          document.querySelector("input[name='tagsEventsLu']").value = existingTagsEventsLu ? existingTagsEventsLu + "," + value : value;
          document.querySelector("input[name='categories']").value = "";
        }

        const submitEvent = new Event("submit", { cancelable: true });
        formEvent.dispatchEvent(submitEvent);
      });
    }
  }

  if (document.querySelectorAll(".js-select-audience-events").length > 0) {
    const selectCategories = document.querySelectorAll(".js-select-audience-events");

    for (const selectCategory of selectCategories) {
      selectCategory.addEventListener("change", function () {
        console.log("Audience", selectCategory.value);
        const submitEvent = new Event("submit", { cancelable: true });
        formEvent.dispatchEvent(submitEvent);
      });
    }
  }

  if (document.querySelectorAll(".js-btn-date-event").length > 0) {
    const btnDateEvents = document.querySelectorAll(".js-btn-date-event");

    // RAWeb 3.1 : l'état actif ne doit pas reposer uniquement sur la couleur.
    // On marque le filtre actif initial (soulignement + aria-current).
    for (const btnDateEvent2 of btnDateEvents) {
      if (btnDateEvent2.classList.contains("bg-red-lcto")) {
        btnDateEvent2.classList.add("underline");
        btnDateEvent2.setAttribute("aria-current", "true");
      }
    }

    for (const btnDateEvent of btnDateEvents) {
      btnDateEvent.addEventListener("click", function () {
        document.querySelector("#date-event-start").value = btnDateEvent.dataset.frombtn;
        document.querySelector("#date-event-end").value = btnDateEvent.dataset.tobtn;

        for (const btnDateEvent2 of btnDateEvents) {
          btnDateEvent2.classList.remove("bg-red-lcto", "text-white", "underline");
          btnDateEvent2.classList.add("bg-white", "text-text-lcto");
          btnDateEvent2.removeAttribute("aria-current");
        }

        btnDateEvent.classList.remove("bg-white", "text-text-lcto");
        btnDateEvent.classList.add("bg-red-lcto", "text-white", "underline");
        btnDateEvent.setAttribute("aria-current", "true");

        document.querySelector("#page-to-fetch").value = "";
        document.querySelectorAll(".js-btn-load-more-event-month").forEach((btn) => {
          btn.setAttribute("data-page", 2);
        });

        const submitEvent = new Event("submit", { cancelable: true });
        formEvent.dispatchEvent(submitEvent);
      });
    }
  }

  if (document.querySelectorAll(".js-select-change-categ").length > 0) {
    const selectChangeCategories = document.querySelectorAll(".js-select-change-categ");

    for (const selectChangeCategory of selectChangeCategories) {
      selectChangeCategory.addEventListener("change", function () {
        document.querySelector(".js-select-categorie-events").value = selectChangeCategory.value;
        const changeEvent = new Event("change", { cancelable: true });
        document.querySelector(".js-select-categorie-events").dispatchEvent(changeEvent);
      });
    }
  }

  if (document.querySelectorAll(".js-select-change-audience").length > 0) {
    const selectChangeAudiences = document.querySelectorAll(".js-select-change-audience");

    for (const selectChangeAudience of selectChangeAudiences) {
      selectChangeAudience.addEventListener("change", function () {
        document.querySelector(".js-select-audience-events").value = selectChangeAudience.value;
        const changeEvent = new Event("change", { cancelable: true });
        document.querySelector(".js-select-audience-events").dispatchEvent(changeEvent);
      });
    }
  }
});
